export default [
  {
    path: 'studio',
    redirect: 'studio/teachers',
    component: () => import(/* webpackChunkName: "studio" */ '@/views/Studio'),
    meta: {
      keepAlive: false
    },
    children: [
      {
        name: 'studio-teachers',
        path: 'teachers',
        component: () => import(/* webpackChunkName: "studio-teachers" */ '@/views/Studio/Teachers'),
        meta: {
          keepAlive: true
        }
      },
      {
        name: 'studio-tools',
        path: 'tools',
        component: () => import(/* webpackChunkName: "studio-tools" */ '@/views/Studio/Tools'),
        meta: {
          keepAlive: true
        }
      },
      {
        name: 'studio-user',
        path: 'user',
        component: () => import(/* webpackChunkName: "studio-user" */ '@/views/Studio/User'),
        meta: {
          keepAlive: true
        }
      },
      {
        name: 'studio-commodities',
        path: 'commodities',
        component: () => import(/* webpackChunkName: "studio-commodities" */ '@/views/Studio/Commodities'),
        meta: {
          keepAlive: true
        }
      }
    ]
  }
]
